var map = {
	"./accounts-icon-white.png": 1729,
	"./accounts-icon.png": 1730,
	"./add-icon-blue.png": 123,
	"./add-icon-white.png": 259,
	"./add-icon.png": 60,
	"./agregar-efectivo.png": 929,
	"./back-blue-arrow.png": 1731,
	"./bank-icon-white.png": 1732,
	"./bank-icon.png": 1733,
	"./bar-icon.png": 1734,
	"./billete1.png": 520,
	"./billete10.png": 521,
	"./billete100.png": 522,
	"./billete20.png": 523,
	"./billete200.png": 524,
	"./billete5.png": 525,
	"./billete50.png": 526,
	"./bodega-ajuste.png": 930,
	"./bodega-baja.png": 931,
	"./bodega-icon-white.png": 1735,
	"./bodega-icon.png": 1736,
	"./bodega-ingreso.png": 932,
	"./box-icon-white.png": 527,
	"./cancel-icon-white.png": 318,
	"./cancel-sale-icon-gris.png": 933,
	"./car-shop-icon.png": 528,
	"./cash-box-icon-white.png": 1737,
	"./cash-box-icon.png": 1738,
	"./cash-box.png": 934,
	"./cashBox.png": 935,
	"./cashBoxActive.png": 936,
	"./categories-icon-white.png": 1739,
	"./categories-icon.png": 1740,
	"./check-icon-green.png": 381,
	"./check-patient-icon.png": 529,
	"./clear-icon-white.png": 937,
	"./cobrar-icon-blue-antiguo.png": 1741,
	"./cobrar-icon-blue.png": 319,
	"./configuration-icon-white.png": 1742,
	"./configuration-icon.png": 1743,
	"./consult-icon-white.png": 1744,
	"./consult-icon.png": 1745,
	"./cuenta-abierta-gris.png": 530,
	"./cupon-icon-gris.png": 938,
	"./cupon.png": 1746,
	"./delete-icon.png": 44,
	"./delete-patient-icon.png": 124,
	"./down-arrow-icon.png": 939,
	"./down-arrow-white-icon.png": 148,
	"./edit-icon-blue-2.png": 1747,
	"./edit-icon-blue.png": 1748,
	"./edit-icon.png": 382,
	"./empty-check-blue.png": 940,
	"./fill-check-blue.png": 941,
	"./history-icon-orange.png": 320,
	"./history-icon-white.png": 383,
	"./home-icon-white.png": 1749,
	"./home-icon.png": 1750,
	"./igss-black.png": 1751,
	"./igss-gray.png": 1752,
	"./institution-icon-white.png": 1753,
	"./institution-icon.png": 1754,
	"./lefth-arrow-icon.png": 942,
	"./lock-icon.png": 928,
	"./logged-user-icon.png": 943,
	"./moneda1.png": 531,
	"./moneda10.png": 532,
	"./moneda1c.png": 533,
	"./moneda25.png": 534,
	"./moneda5.png": 535,
	"./moneda50.png": 536,
	"./notification-icon.png": 944,
	"./off-switch.png": 1755,
	"./ojo-circular-derecho-azul.png": 1756,
	"./ojo-circular-derecho-gris.png": 537,
	"./ojo-circular-derecho-mod-azul.png": 945,
	"./ojo-circular-izquierdo-azul.png": 1757,
	"./ojo-circular-izquierdo-gris.png": 538,
	"./ojo-circular-izquierdo-mod-azul.png": 946,
	"./ojo-derecho-azul.png": 947,
	"./ojo-derecho-gris.png": 539,
	"./ojo-derecho-ramas-azul.png": 948,
	"./ojo-izquierdo-azul.png": 949,
	"./ojo-izquierdo-gris.png": 384,
	"./ojo-izquierdo-ramas-azul.png": 950,
	"./on-switch.png": 1758,
	"./order-icon-white.png": 540,
	"./order-icon.png": 1759,
	"./package-icon-2.png": 1760,
	"./package-icon-green.png": 541,
	"./package-icon.png": 542,
	"./password-eye-icon.png": 951,
	"./password-slash-eye-icon.png": 952,
	"./patients-icon-white.png": 1761,
	"./patients-icon.png": 1762,
	"./pausa-icon-blue.png": 953,
	"./payback_payment_icon.png": 543,
	"./pdf.png": 925,
	"./plan-icon-white.png": 1763,
	"./plan-icon.png": 954,
	"./print-icon-white.png": 385,
	"./products-icon-white.png": 1764,
	"./products-icon.png": 1765,
	"./provider-icon-white.png": 1766,
	"./provider-icon.png": 1767,
	"./puntero-icon.png": 955,
	"./reference-icon-white.png": 1768,
	"./reference-icon.png": 1769,
	"./referents-icon-white.png": 1770,
	"./referents-icon.png": 1771,
	"./reports-icon-white.png": 1772,
	"./reports-icon.png": 1773,
	"./retirar-efectivo.png": 1774,
	"./return-icon-blue.png": 321,
	"./return-icon-white.png": 189,
	"./review.png": 956,
	"./right-arrow-icon.png": 957,
	"./right-arrow-white-icon.png": 1775,
	"./round-check-icon.png": 1776,
	"./sales-icon-white.png": 1777,
	"./sales-icon.png": 1778,
	"./save-icon-gris.png": 544,
	"./save-icon-white.png": 958,
	"./schedule-icon-white.png": 1779,
	"./schedule-icon.png": 1780,
	"./search-icon.png": 545,
	"./service-icon-green.png": 546,
	"./service-icon.png": 547,
	"./set-account.png": 548,
	"./start-icon-blue.png": 1781,
	"./start-icon-white.png": 959,
	"./stop-icon-blue.png": 960,
	"./task-icon-white.png": 1782,
	"./task-icon.png": 1783,
	"./undo-icon-white.png": 961,
	"./up-arrow-icon.png": 962,
	"./up-arrow-white-icon.png": 149,
	"./user-icon.png": 927,
	"./users-icon-white.png": 1784,
	"./users-icon.png": 1785,
	"./view-icon.png": 93
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1728;